(function initializePrimerProducts() {
  const syncStickyCta = () => {
    document.body.classList.toggle(
      'lp-primer-sticky-cta-active',
      Boolean(document.querySelector('[data-lp-primer-sticky-cta]'))
    );
  };

  const setupDescriptions = (scope = document) => {
    scope.querySelectorAll('[data-product-description-toggle]').forEach((toggle) => {
      const container = toggle.closest('.product__description--collapsible');
      const content = container?.querySelector('[data-product-description-content]');
      if (!container || !content || toggle.dataset.initialized) return;

      const updateVisibility = () => {
        const wasExpanded = container.classList.contains('is-expanded');
        container.classList.remove('is-expanded');
        const hasOverflow = content.scrollHeight > content.clientHeight + 1;
        toggle.hidden = !hasOverflow;
        if (wasExpanded && hasOverflow) {
          container.classList.add('is-expanded');
        } else {
          toggle.setAttribute('aria-expanded', 'false');
          toggle.textContent = toggle.dataset.moreText;
        }
      };

      toggle.dataset.initialized = 'true';
      toggle.addEventListener('click', () => {
        const isExpanded = container.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', String(isExpanded));
        toggle.textContent = isExpanded ? toggle.dataset.lessText : toggle.dataset.moreText;
      });
      updateVisibility();
      window.addEventListener('resize', updateVisibility, { passive: true });
    });
  };

  const setupCombo = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const section = root.closest('[id^="shopify-section-"]');
    const forms = section?.querySelectorAll('form[data-lp-primer-ajax-cart]') || [];
    const targetInputs = section?.querySelectorAll('input[data-combo-target-input]') || [];
    const radios = root.querySelectorAll('input[data-combo-variant-id]');

    const toggleButtons = (available) => forms.forEach((form) => {
      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = !available;
    });

    const applyChoice = (radio) => {
      const variantId = radio.dataset.comboVariantId || radio.value;
      const available = radio.dataset.comboAvailable === 'true' && Boolean(variantId);
      targetInputs.forEach((input) => { input.value = variantId; });
      toggleButtons(available);
      root.querySelectorAll('.lp-primer-product__option').forEach((option) => {
        option.classList.toggle('is-selected', option.contains(radio));
      });
    };

    radios.forEach((radio) => {
      radio.addEventListener('change', () => applyChoice(radio));
      if (radio.checked) applyChoice(radio);
    });

    forms.forEach((form) => form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      const submitButton = form.querySelector('button[type="submit"]');
      const variantInput = form.querySelector('input[name="id"]');
      const variantId = variantInput?.value;
      if (!submitButton || submitButton.classList.contains('loading') || !variantId) return;

      const quantity = Math.max(1, parseInt(form.querySelector('input[name="quantity"]')?.value || '1', 10) || 1);
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
      submitButton.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message);
        window.location.href = '/checkout';
      } catch (error) {
        console.error(error);
        alert(error.message || 'Não foi possível ir para o checkout.');
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        submitButton.disabled = false;
      }
    }));
  };

  const initialize = (scope = document) => {
    syncStickyCta();
    setupDescriptions(scope);
    scope.querySelectorAll('[data-product-combo-root]').forEach(setupCombo);
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', () => setTimeout(syncStickyCta, 0));
})();
